module.exports = __webpack_public_path__ + "static/media/shell helix.19f2cf00.png";